import { render } from "./Ma5drTrend.vue?vue&type=template&id=3c5d5c91&scoped=true"
import script from "./Ma5drTrend.vue?vue&type=script&lang=js"
export * from "./Ma5drTrend.vue?vue&type=script&lang=js"

import "./Ma5drTrend.vue?vue&type=style&index=0&id=3c5d5c91&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5d5c91"]])

export default __exports__